import { useState, useEffect, useRef } from "react";
import { AddressFinder } from "@ideal-postcodes/address-finder";
import { nonMainlandPostCode } from "../helper";
import Title from "./Title";

export default function Address({ type }) {
  const [showPopup, setShowPopup] = useState(false);
  const [address, setAddress] = useState({
    line_1: "",
    line_2: "",
    line_3: "",
    post_town: "",
    postcode: "",
    county: "",
  });
  const formRef = useRef(null);
  const shouldRender = useRef(true);

  const mediaUrl =
    process.env.NODE_ENV === "development"
      ? "./"
      : "/wp-content/reactpress/apps/sdh-booking-form/build/";

  useEffect(() => {
    if (!shouldRender.current) return;
    shouldRender.current = false;

    AddressFinder.watch({
      inputField: `#${type}_address_1`,
      apiKey: process.env.REACT_APP_ADDRESS_API,
      onAddressRetrieved: (addressResult) => {
        setAddress({
          line_1: addressResult.line_1,
          line_2: addressResult.line_2,
          post_town: addressResult.post_town,
          postcode: addressResult.postcode,
          county: addressResult.county,
        });
      },
    });
  }, [type]);

  const checkPostcode = (postcode, addressType) => {
    const invalid = nonMainlandPostCode(postcode);

    if (invalid) {
      setShowPopup(true);
      resetForm(addressType);
    } else {
      setAddress({ ...address, postcode: postcode });
    }

    return invalid;
  };

  const resetForm = (addressType) => {
    const inputs = formRef.current.querySelectorAll(
      `.${addressType}-address-input`,
    );

    inputs.forEach((input) => {
      if (input.name === `${addressType}_name`) {
        return;
      } else if (input.type === "checkbox" || input.type === "radio") {
        input.checked = false;
      } else {
        input.value = "";
      }
    });
  };

  const classes = `${type}-address-input border border-primary rounded-xl p-4 bg-white shadow-lg`;
  return (
    <div ref={formRef} className="grid grid-cols-1 md:grid-cols-2 gap-8 mb-4">
      <input
        id={`${type}_name`}
        name={`${type}_name`}
        type="text"
        className={classes}
        placeholder="Full Name"
        pattern=".*\S+.*"
        title="This field is required"
        autoComplete="off"
        required
      />
      <input
        id={`${type}_address_1`}
        name={`${type}_address_1`}
        type="text"
        className={classes}
        placeholder="Address Line 1 (search)"
        autoComplete="off"
        pattern=".*\S+.*"
        title="This field is required"
        data-address-type={type}
        required
        value={address.line_1}
        onChange={(e) => setAddress({ ...address, line_1: e.target.value })}
      />
      <input
        id={`${type}_address_2`}
        name={`${type}_address_2`}
        type="text"
        className={classes}
        placeholder="Address Line 2"
        value={address.line_2}
        onChange={(e) => setAddress({ ...address, line_2: e.target.value })}
      />
      <input
        id={`${type}_city`}
        name={`${type}_city`}
        type="text"
        className={classes}
        placeholder="City"
        pattern=".*\S+.*"
        title="This field is required"
        required
        value={address.post_town}
        onChange={(e) => setAddress({ ...address, post_town: e.target.value })}
      />
      <input
        id={`${type}_county`}
        name={`${type}_county`}
        type="text"
        className={classes}
        placeholder="County"
        value={address.county}
        onChange={(e) => setAddress({ ...address, county: e.target.value })}
      />
      <input
        id={`${type}_postcode`}
        name={`${type}_postcode`}
        type="text"
        className={classes}
        placeholder="Postcode"
        onChange={(e) => checkPostcode(e.target.value, type)}
        pattern=".*\S+.*"
        title="This field is required"
        required
        value={address.postcode}
      />
      {showPopup && (
        <section className="delivery-popup text-center">
          <div>
            <a href="/">
              <img
                src={`${mediaUrl}logo.png`}
                alt="Silent Disco Logo"
                className="mx-auto my-8 max-h-28"
              />
            </a>
            <Title
              Tag="h2"
              text="Contact Us"
              highlighted="for delivery options."
            />
            <p className="max-w-4xl mx-auto md:text-2xl font-medium">
              We don't currently deliver to your chosen location please select a
              different delivery / collection address or get in touch.
              <br />
              <br />
              Please call <a href="tel:+4402084326151">0208 432 6151</a> or
              email{" "}
              <a href="mailto:info@thesilentdiscocompany.co.uk">
                info@thesilentdiscocompany.co.uk
              </a>
              <br />
              <br />
              Our friendly team will be happy to assist you.
            </p>
            <button
              className="btn btn-primary btn-solid"
              onClick={(e) => setShowPopup(false)}
            >
              Change Address
            </button>
          </div>
        </section>
      )}
    </div>
  );
}
